import { EntityItem, EntityItemDetail } from '@/entities/entityItem';

export function intoEditable(data: EntityItemDetail): EntityItem {
  return {
    ...data.data,
    entityTypeId: data.data.entityType?.id ?? null,
    users: data.data.users.map(user => user.id),
  };
}
